module.exports = __webpack_public_path__ + "static/media/cases_3d_keslon_03c.7792e25a.jpg";